<template>
  <section class="tw-px-4">
    <div class="container tw-mx-auto">
      <div>
        <div class="tw-flex tw-items- tw-py-1 tw-px-4 md:tw-px-0">
          <div class="tw-flex">
            <BackBtn class="tw-hidden sm:tw-block tw-mr-6" />
            <div>
              <h1 class="tw-text-2xl tw-font-bold">
                {{ formHeading }}
              </h1>
              <p class="tw-text-sm tw-text-black-light">
                {{ formSubHeading }}
              </p>
            </div>
          </div>
          <div
            class="tw-h-8 tw-bg-orange-bg1 tw-rounded tw-py-1 tw-px-4 tw-ml-4"
          >
            <p class="tw-text-orange tw-whitespace-nowrap">{{ step }} of 2</p>
          </div>
        </div>
      </div>
      <KeepAlive>
        <component
          class="tw-px- tw-mt-10"
          :is="currentForm"
          @next-page="goToNextPage"
          buttonText="Create ESO"
        ></component>
      </KeepAlive>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EsopTokenForm from "@/components/employeesBenefit/forms/EsopTokenForm";
import VestingSchedule from "@/components/employeesBenefit/forms/VestingSchedule";
import { removeItem } from "@/utils/storage.js";
import BackBtn from "@/components/general/BackBtn";
export default {
  name: "CreateStockOptions",
  data() {
    return {
      currentForm: "EsopTokenForm",
      formSubHeading: "",
      formHeading: "",
      step: 1,
    };
  },
  components: {
    EsopTokenForm,
    VestingSchedule,
    BackBtn,
  },

  created() {
    this.getFormText();
    removeItem("asset_name");
  },
  watch: {
    currentForm: "getFormText",
    esopToken(val) {
      if (val) {
        this.currentForm = "VestingSchedule";
        this.step = this.currentForm === "VestingSchedule" ? 2 : 1;
      }
    },
    vestingSchedule(val) {
      if (val) {
        this.$router.push({ name: "InviteEmployee" });
      }
    },
  },
  computed: {
    ...mapGetters("Esop", ["vestingSchedule", "esopToken"]),
  },
  methods: {
    ...mapActions("Esop", ["getVestingSchedule", "getEsopToken"]),
    async getFormText() {
      switch (this.currentForm) {
        case "EsopTokenForm":
          this.formHeading = "Shares Information";
          this.formSubHeading =
            "Fill in the following details about your shares.";
          break;
        case "VestingSchedule":
          this.formHeading = "Set up a Default Vesting Schedule";
          this.formSubHeading =
            "This would be available when inviting new users";
          break;
      }
      try {
        await Promise.all([this.getVestingSchedule(), this.getEsopToken()]);
      } catch (error) {
        return error;
      }
    },
    goToNextPage(currentPage) {
      switch (currentPage) {
        case "EsopTokenForm":
          this.currentForm = "VestingSchedule";
          this.step = 2;
          break;
        case "VestingSchedule":
          this.$router.push({ name: "EmployeeBenefits" });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  // border: 1px solid #f1f3f6;
  max-width: 818px;
  // @media (min-width: 1440px) {
  //   max-width: 1200px;
  // }
}
</style>
